import setTextColorBasedOnBg from './setTextColorBasedOnBg';

const WebToTextColorTypes = {
    Default: 0,
    Solid: 1,
    Gradient: 2
};

const setWebToTextStyles = (root, borderColor, staticDark, webToText) => {
    const {
        webToTextBackgroundColor,
        webToTextBackgroundGradientColor,
        webToTextColorType = WebToTextColorTypes.Default
    } = webToText;
    const hasBgColor = webToTextColorType === WebToTextColorTypes.Solid;
    const hasGradient = webToTextColorType === WebToTextColorTypes.Gradient;

    let textColor = staticDark;
    let background = '#FFFFFF';
    let border = borderColor;
    let borderSize = ''; // Default: no override

    if (hasBgColor) {
        textColor = setTextColorBasedOnBg(webToTextBackgroundColor);
        background = webToTextBackgroundColor;
        border = webToTextBackgroundColor;
    }

    if (hasGradient) {
        background = `linear-gradient(90deg, ${webToTextBackgroundColor} 0%, ${webToTextBackgroundGradientColor} 100%)`;
        border = 'transparent';
        borderSize = '0px';
        textColor = setTextColorBasedOnBg(webToTextBackgroundColor);
    }

    const rootStyle = root.documentElement.style;
    rootStyle.setProperty('--webToTextColor', textColor);
    rootStyle.setProperty('--webToTextBg', background);
    rootStyle.setProperty('--webToTextBorder', border);
    if (borderSize) {
        rootStyle.setProperty('--webToTextBorderSize', borderSize);
    }
};

export default setWebToTextStyles;
